import MyProfileIcon from "../icons/ProfileMenuIcons/MyProfileIcon.svg?react";
import ManageIcon from "../icons/ProfileMenuIcons/ManageIcon.svg?react";
import FollowingIcon from "../icons/ProfileMenuIcons/FollowingIcon.svg?react";
import SavedContentIcon from "../icons/ProfileMenuIcons/SavedContentIcon.svg?react";
import MyNichesIcon from "../icons/ProfileMenuIcons/MyNichesIcon.svg?react";
import SettingsIcon from "../icons/ProfileMenuIcons/SettingsIcon.svg?react";
import LogoutIcon from "../icons/ProfileMenuIcons/LogoutIcon.svg?react";
import DashboardIcon from "../icons/dashboard.svg?react";

const ProfileMenuIcons = {
  DashboardIcon,
  FollowingIcon,
  LogoutIcon,
  ManageIcon,
  MyNichesIcon,
  MyProfileIcon,
  SavedContentIcon,
  SettingsIcon,
};

export default ProfileMenuIcons;
